import { render, staticRenderFns } from "./SuratPenunjangFormBaseDigitalSign.vue?vue&type=template&id=60fa83f7&"
import script from "./SuratPenunjangFormBaseDigitalSign.vue?vue&type=script&lang=js&"
export * from "./SuratPenunjangFormBaseDigitalSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports